import { useCustomerData } from "context/customer-provider"
import { Link } from "react-router-dom"
import AppSubmenu from "./AppSubmenu"
import styles from "./AppMenu.module.scss"

const AppMenu = ({
  onMenuClick,
  appName,
  model,
  menuMode,
  active,
  mobileMenuActive,
  onMenuitemClick,
  onRootMenuitemClick,
  onChatClick,
}) => {
  const { customerId, customerData, product } = useCustomerData()
  // Per-customer tagline (config.customer.tagline), else the roads default.
  const tagline = customerData?.customerTagline ?? (product === "roads" ? "Highways Analytics Platform" : null)

  let logoSrc = ""

  switch (customerId) {
    case "NR":
    case "WAGON":
      logoSrc = "/assets/layout/images/nrLogo.png"
      break
    case "PB":
      logoSrc = "/assets/layout/images/pbLogo.png"
      break
    case "3RDRAIL":
      logoSrc = customerData.logo
      break
    default: // already empty string
  }

  const onPBDataCardClick = () => window.open("https://porterbrook.co.uk", "_blank").focus()

  const isPageWithDataByPorterbrook =
    window.location.pathname === "/adhesion-analysis" ||
    window.location.pathname === "/seasonal-analysis" ||
    window.location.pathname === "/lost-time-trains" ||
    window.location.pathname === "/lost-time-tracks"

  const isNRCustomer = customerId === "NR"

  return (
    <div
      id="sidebar-menu"
      className={`layout-sidebar ${styles.sidebar}`}
      onClick={onMenuClick}
      role="button"
      tabIndex={0}
      onKeyDown={onMenuClick}
    >
      <Link to="/" className="logo">
        <img
          id="rr-logo"
          className="logo-image"
          src="/assets/layout/images/logo-white.png"
          alt="rr logo"
        />
        {logoSrc && (
          <img
            id="app-logo"
            className="logo-image"
            src={logoSrc}
            alt="customer logo"
            style={{
              width: customerId === "NR" ? "70%" : customerId === "PB" ? "90%" : null,
              marginLeft: customerId === "NR" ? "15%" : null,
            }}
          />
        )}
        <br />
        <span
          data-testid="customer-app-name"
          className="app-name"
          style={{ 
            display: "table-caption",
            fontSize: appName?.split(" ").some((word) => word.length > 12) ? "0.9rem" : "1.2rem",
            lineHeight: appName?.split(" ").some((word) => word.length > 12) ? "1.1" : "normal",
          }}
        >
          {appName.toUpperCase()}
        </span>
        {tagline && (
          <span data-testid="product-tagline" className="app-name app-tagline">
            {tagline.toUpperCase()}
          </span>
        )}
        {__APP_VERSION__ && (
          <span
            className="app-version"
            style={{ display: "block", fontSize: "0.65rem", opacity: 0.6, marginTop: "2px" }}
          >
            {__APP_VERSION__}
          </span>
        )}
      </Link>
      <div className="layout-menu-container">
        <AppSubmenu
          items={model}
          menuMode={menuMode}
          parentMenuItemActive
          menuActive={active}
          mobileMenuActive={mobileMenuActive}
          root
          onMenuitemClick={onMenuitemClick}
          onRootMenuitemClick={onRootMenuitemClick}
        />
        <div style={{ marginTop: "20%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
            }}
          >
            {isPageWithDataByPorterbrook && (
              <div
                className="card no-gutter widget-overview-box widget-overview-box-1"
                onClick={onPBDataCardClick}
                style={{ cursor: "pointer" }}
                role="button"
                tabIndex={0}
                onKeyDown={onPBDataCardClick}
                id="data-by-porterbrook-logo"
              >
                <span className="overview-title">DATA BY</span>
                <div className="p-grid overview-detail">
                  <img
                    id="app-logo"
                    className="logo-image"
                    src="/assets/layout/images/pbLogo.png"
                    alt="pb logo"
                    style={{ width: "60%", marginLeft: "15%" }}
                  />
                </div>
              </div>
            )}
            {isNRCustomer && (
              <div className="card no-gutter widget-overview-box widget-overview-box-1">
                <p style={{ fontSize: "0.8rem" }}>
                  Disclaimer: The information shown can not be solely relied upon for any
                  safety-related decisions, nor should any critical decisions be made based on the
                  data without checking other sources.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Tablets and phones: Intercom's floating launcher would cover the
          pages' own bottom-right controls, so the chat lives here (CSS shows
          it below 992px only; see intercomLauncherHidden). */}
      <button type="button" className={styles.chatButton} onClick={onChatClick}>
        <i className="pi pi-comments" aria-hidden="true" />
        Chat with support
      </button>
    </div>
  )
}

export default AppMenu
